<script>
import VideoBackground from '@/components/_common/special/VideoBackground'
import SystemRequirements from '@/components/_common/SystemRequirements.vue'
import BaseModal from '@/components/_common/modal/BaseModal.vue'
export default {
  name: 'CustomizableTools',
  components: {
    SystemRequirements,
    VideoBackground,
    BaseModal
  },
  data () {
    return {
      showRequirementsModal: false
    }
  },
  computed: {
    vidDimensions () {
      let dims = {
        width: '42rem',
        height: '25rem'
      }
      switch (this.$mq) {
        case 'mobile':
          dims = {
            width: 'calc(100vw - 2rem)',
            height: 'auto'
          }
          break
        case 'tablet':
          dims = {
            width: 'calc(50vw - 2rem)',
            height: 'auto'
          }
          break
        case 'desktop':
          dims = {
            width: '31.5rem',
            height: '18.75rem'
          }
          break
        case 'widescreen':
          dims = {
            width: '42rem',
            height: '25rem'
          }
          break
      }
      return dims
    }
  }
}
</script>

<template>
  <section class="customizable-section">
    <div class="flexi-grid">
      <section id="grid-video">
        <video-background
          :video-source="require('@/assets/promo/video/CustomizableTools/games.webm')"
          :poster-image="require('@/assets/promo/img/home/CustomizableTools/games_poster.webp')"
          aspect-ratio="16/9"
          :height="vidDimensions.height"
          :width="vidDimensions.width"
          class="game-video"
        />
      </section>
      <section id="grid-content-desktop">
        <header>
          <h2 class="article-title mb-4">Built for Real-World Caseloads</h2>
          <h3 class="article-subtitle mb-4">OVB supports mixed diagnoses and patient populations within one consistent therapy platform</h3>
        </header>
        <div>
          <ul class="list-discs points-of-interest article-body text-semibold">
            <li class="poi">Binocular vision therapy including amblyopia and strabismus</li>
            <li class="poi">Neuro-rehabilitation including concussion care</li>
            <li class="poi">Neurodivergent profiles</li>
            <li class="poi">Reading and academic challenges</li>
            <li class="poi">Sports vision applications</li>
            <li class="poi">Pediatric through adult patients</li>
          </ul>
        </div>
        <button
          class="button is-info is-outlined mt-4"
          @click="showRequirementsModal = !showRequirementsModal"
        >
      <span class="icon is-medium mr-1">
        <i class="mdi mdi-information"></i>
      </span>
          View System Requirements
        </button>
      </section>
      <section>
        <header id="section-title-mobile">
          <h2 class="article-title">Built for Real-World Caseloads</h2>
          <h3 class="article-subtitle mb-4">OVB supports mixed diagnoses and patient populations within one consistent therapy platform</h3>
        </header>
      </section>
      <div id="section-content-mobile">
        <ul class="list-discs points-of-interest article-body text-semibold">
          <li class="poi">Binocular vision therapy including amblyopia and strabismus</li>
          <li class="poi">Neuro-rehabilitation including concussion care</li>
          <li class="poi">Neurodivergent profiles</li>
          <li class="poi">Reading and academic challenges</li>
          <li class="poi">Sports vision applications</li>
          <li class="poi">Pediatric through adult patients</li>
        </ul>
        <button
          class="button is-info is-outlined mt-4"
          @click="showRequirementsModal = !showRequirementsModal"
        >
      <span class="icon is-medium mr-1">
        <i class="mdi mdi-information"></i>
      </span>
          View System Requirements
        </button>
      </div>
    </div>
    <base-modal
      :show="showRequirementsModal"
      @CLOSE_MODAL="showRequirementsModal = false"
      :has-close-button="true"
      :close-on-mask-click="true"
      :full-screen="false"
      :has-footer="false"
    >
      <template #header>
        System Requirements
      </template>
      <template #content>
        <system-requirements />
      </template>
    </base-modal>
  </section>
</template>

<style scoped lang="scss">
.flexi-grid {
  display: grid;
  grid-template-areas:
    "title-mobile"
    "vid"
    "content-mobile";
  grid-template-columns: 1fr;
  grid-column-gap: 2rem;
  grid-row-gap: 1rem;
  @include tablet {
    grid-template-areas:
    "content-dekstop vid";
    grid-template-columns: 1fr 1fr;
  }
  @include desktop {
    grid-template-areas:
    "content-dekstop vid";
    grid-template-columns: 1fr 1fr;
  }
}
#grid-video {
  grid-area: vid;
}
#grid-content-desktop {
  grid-area: content-dekstop;
  display: none;
  @include tablet {
    display: block;
  }
  @include desktop {
    display: block;
  }
}
#section-title-mobile {
  grid-area: title-mobile;
  display: block;
  @include tablet {
    display: none;
  }
  @include desktop {
    display: none;
  }
}
#section-content-mobile{
  grid-area: content-mobile;
  display: block;
  @include tablet {
    display: none;
  }
  @include desktop {
    display: none;
  }
}
  .game-video {
    border-radius: 0.375rem;
    display: inline-block;
    overflow: hidden;
    box-shadow: 0 0.5em 1em -0.125em rgba(10.2, 10.2, 10.2, 0.1), 0 0px 0 1px rgba(10.2, 10.2, 10.2, 0.02);
  }
  .list-title {
    font-size: $size-3;
    line-height: $size-3;
    color: $feldgrau;
    font-weight: $font-semibold;;
  }
  .points-of-interest {
    li {
      //font-weight: $font-semibold;;
      //color: $gray-darker;
      color: $feldgrau;
    }
  }
</style>
